import Header from './Components/Header';
import CarouselBody from './Components/Carousel-Body';

function ReviewsApp() {
    return (
        <div style={{ backgroundColor: "azure", overflow: "hidden", height: "100vh"}}>
            <Header />
            <CarouselBody />
        </div>
    );
}

export default ReviewsApp;